import { myResourceTypeBindingsApi } from 'v5/api/resource-types/resource-type-bindings.api.connected';
import { queryClient } from 'v4/migration/queryClientSingleton';
import { createResourceTypeBindingsService } from './ResourceTypeBindingsService.impl';

/**
 * Shared bindings service used by admin UI and runtime consumers
 * (ResourceTypeService, MetastructureMappingService).
 *
 * API: HTTP (`resource-type-bindings.api.connected.ts`).
 */
export const myResourceTypeBindingsService = createResourceTypeBindingsService({
  api: myResourceTypeBindingsApi,
  queryClient
});
